import {Component, OnDestroy, OnInit} from '@angular/core';
import {DropdownOption} from "../../../../../../models/dropdown-option.model";
import * as Validation
  from "../../../../../shared/constants/validation.constants";
import {Filter} from "../../../../../../models/filter";
import {roles} from "../../../../../shared/constants/common.constants";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {debounceTime, Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from "../../../../../shared/services/common.service";
import {
  FetchGroupListFilterRequest,
  FetchUserStatusListFilterRequest,
  SaveConfigId
} from "../../../core/admin-groups-list.actions";
import {
  groupListFilter,
  userStatusListFilter
} from "../../../core/admin-groups-list.selectors";
import {
  AdminGroupListService
} from "../../../services/admin-group-list.service";

@Component({
  selector: 'app-participant-behaviour-information-filter',
  templateUrl: './participant-behaviour-information-filter.component.html',
  styleUrls: ['./participant-behaviour-information-filter.component.css']
})
export class ParticipantBehaviourInformationFilterComponent implements OnInit,
                                                                       OnDestroy {
  loading: boolean = false;
  statusFilterList: DropdownOption[] = [];
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    'groupId': {
      required: 'This field is required.'
    },
    'role': {
      required: 'This field is required.'
    },
    'session': {
      required: 'This field is required.'
    },
    'status': {
      required: 'This field is required.'
    },
    'searchText': {
      required: 'This field is required.'
    },
  }
  clientOptions: Filter = {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  };
  groupOptions: Filter = {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  };

  roleFilterList: DropdownOption[] = [
    {
      key: roles.adult,
      value: 'Adult',
    },
    {
      key: roles.participant,
      value: 'Participant',
    },
  ];

  sessionFilterList: DropdownOption[] = [
    {
      key: 1,
      value: 'Up to S26',
    },
    {
      key: 2,
      value: 'After S26',
    },
  ];

  form = new FormGroup({
    groupId: new FormControl(null, {
      validators: [
        Validators.required
      ],
    }),
    role: new FormControl([roles.participant]),
    session: new FormControl({value: 1, disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    status: new FormControl(null),
    searchText: new FormControl(null),
    searchGroup: new FormControl(''),
  })
  config = [
    {
      id: 1,
      label: 'Red Light Foods',
      isSelected: true
    },
    {
      id: 2,
      label: 'Physical Activity',
      isSelected: false
    },
    {
      id: 3,
      label: 'Screen Time',
      isSelected: false
    }

  ]
  clientId: any;
  private readonly OnDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private commonService: CommonService,
    private adminGroupListService: AdminGroupListService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.store.dispatch(FetchUserStatusListFilterRequest())
  }

  ngOnInit() {
    this.triggerFiltering();

    this.clientId = this.activatedRoute.snapshot.paramMap.get('clientId');
    this.fetchGroupFilterList();

    this.store.select(userStatusListFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        this.statusFilterList = data.list;
      });

    this.store.select(groupListFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        this.groupOptions.list.push(...data?.list || []);
        this.groupOptions.hasNext = data?.hasNext
        this.groupOptions.loading = data?.loading;
        if (data.list.length && this.groupOptions.pageNumber === 1) {
          this.form.controls.groupId.setValue(this.groupOptions.list[0]?.key);
          this.triggerFiltering();
        }
      });

    this.form.controls.searchGroup.valueChanges
      .pipe(debounceTime(1000), takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.groupOptions.pageNumber = 1;
        this.groupOptions.list = [];
        this.fetchGroupFilterList();
      });
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    if (!this.form.dirty) { // check is there any change
      return;
    }
    // changes just applied, so marking the form as un-dirty to avoid applying same filters again without changing anything
    this.form.markAsPristine();

    this.triggerFiltering();
  }

  triggerFiltering() {
    // EXTRACT VALUE FROM FORM//
    const {searchGroup, ...filters} = this.form.getRawValue();
    this.adminGroupListService.onParticipantBehaviourInformationFilterChange.next(filters)
  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  select(configId) {
    this.config.map((e) => {
      e.isSelected = e.id === configId;
    });
    this.store.dispatch(SaveConfigId({configId}));
  }

  fetchGroupFilterList() {
    const payload: any = {
      pageNumber: this.groupOptions?.pageNumber,
      limit: this.groupOptions?.limit,
      shouldInclude: this.form.value.groupId,
      ...(this.clientId ? {clientId: this.clientId} : {})
    };
    if (this.form.controls?.searchGroup?.value.trim()) {
      payload.search = this.form.controls.searchGroup.value;
    }
    this.store.dispatch(FetchGroupListFilterRequest({payload}));
  }

  groupOnNextPage() {
    this.groupOptions.pageNumber = this.groupOptions.pageNumber + 1
    this.fetchGroupFilterList();
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }
}
